import * as React from "react";
import { Button } from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";
import { cloneDeep, get } from "lodash";
import { CpInput } from "../../../../gvc/testNewForm/CpInput";
import { FormListFieldItem } from "../../../../gvc/formListFieldItem";
import { store } from "../../../../../store";
import { formSet, formSetValue, formTriggerValidation } from "../../../../gvc/testNewForm/utils";
import { AWSProviderDeployRoleChainInput } from "../../../../../schema/types/mk8s/input/aws";
import { useCpFormContext } from "../../../../../components/form/useCpFormContext";

interface Props {
  name?: string;
  item?: AWSProviderDeployRoleChainInput;
  index?: number;
}
export const CpArrayItemDeployRoleChain: React.FC<Props> = React.memo(({ name: _name, item: _item, index: _index }) => {
  const { id } = useCpFormContext();

  const name = _name!;
  const item = _item!;
  const index = _index!;

  function remove() {
    const form = store.getState().form.instances[id];
    const values = form.values;
    const items = get(values, name) || [];
    let _items = cloneDeep(items);
    _items = _items.filter((i) => i.id !== item.id);
    formSetValue(id, name, _items);

    formTriggerValidation(id);
  }

  return (
    <FormListFieldItem columnCount={3} hasRemoveButton className="mb-1">
      <CpInput name={`${name}.${index}.roleArn`} className={`col-span-1`} />
      <CpInput name={`${name}.${index}.externalId`} className={`col-span-1`} />
      <CpInput name={`${name}.${index}.sessionNamePrefix`} className={`col-span-1`} />
      <Button type={`text`} danger icon={<MinusCircleOutlined />} onClick={() => remove()} />
    </FormListFieldItem>
  );
});
